<template>
    <v-container fluid>
        <template v-if="this.customer">
            <v-card class="mb-5">
                <customer-tabs
                    :customer="customer.id"
                    v-if="isBusinessConsultant"
                ></customer-tabs>

                <CardHeader
                    :title="
                        $t('customer.title', {
                            'title-prefix': $t('customer.show.title-prefix'),
                        })
                    "
                    :route="{ name: 'customer' }"
                ></CardHeader>
                <v-card-text>
                    <v-row>
                        <v-col
                            :cols="customer.activePlan ? 6 : 12"
                            xs="12"
                            sm="12"
                            :md="customer.activePlan ? 6 : 12"
                        >
                            <customer-details :customer="customer" />
                        </v-col>
                        <v-col align-self="center" v-if="customer.activePlan">
                            <div>
                                <v-row class="text-center">
                                    <v-col class="py-5">
                                        <div class="body-3 font-weight-light">
                                            {{
                                                $t(
                                                    'customer.plan.last-plan-name',
                                                )
                                            }}
                                        </div>
                                        <h3 class="display-1 font-weight-light">
                                            {{ customer.activePlan.name }}
                                        </h3>
                                    </v-col>
                                    <v-divider vertical></v-divider>
                                    <v-col class="py-5">
                                        <div class="body-3 font-weight-light">
                                            {{
                                                $t(
                                                    'customer.plan.plan-select-date',
                                                )
                                            }}
                                        </div>
                                        <h3 class="headline font-weight-light">
                                            {{
                                                customer.activePlan
                                                    .formattedActivatedAt
                                            }}
                                        </h3>
                                    </v-col>
                                </v-row>
                                <v-row class="text-center">
                                    <v-col class="py-5">
                                        <div class="body-3 font-weight-light">
                                            {{ $t('customer.plan.plan-value') }}
                                        </div>
                                        <v-row v-if="billable">
                                            <v-col
                                                class="font-weight-light d-flex flex-column"
                                            >
                                                <span class="headline">
                                                    {{
                                                        $n(
                                                            customer.activePlan
                                                                .final_price,
                                                            'currency',
                                                        )
                                                    }}
                                                </span>
                                                <span class="body-2">
                                                    {{
                                                        $t(
                                                            'customer.plan.plan-value-total',
                                                        )
                                                    }}
                                                </span>
                                            </v-col>
                                            <v-col
                                                class="font-weight-light d-flex flex-column"
                                            >
                                                <span class="headline">
                                                    {{
                                                        $n(
                                                            customer.activePlan
                                                                .over_value,
                                                            'currency',
                                                        )
                                                    }}
                                                </span>
                                                <span class="body-2">
                                                    {{
                                                        $t(
                                                            'customer.plan.plan-value-customer',
                                                        )
                                                    }}
                                                </span>
                                            </v-col>
                                        </v-row>
                                        <h3
                                            v-else
                                            class="display-1 font-weight-light"
                                        >
                                            {{
                                                $n(
                                                    customer.activePlan
                                                        .final_price,
                                                    'currency',
                                                )
                                            }}
                                        </h3>
                                    </v-col>
                                    <v-divider vertical></v-divider>
                                    <v-col class="py-5">
                                        <div class="body-3 font-weight-light">
                                            {{
                                                $t('customer.plan.payment-day')
                                            }}
                                        </div>
                                        <h3 class="display-1 font-weight-light">
                                            {{ customer.activePlan.due_day }}
                                        </h3>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mt-4">
                        <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="12"
                            :lg="customer.periods.length ? 6 : 12"
                            v-if="customer.activePlan"
                        >
                            <v-divider class="mb-5"></v-divider>
                            <ModulesTable
                                :plan="customer.activePlan"
                                :isBillable="billable"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="12"
                            lg="6"
                            v-if="customer.periods.length"
                        >
                            <v-divider class="mb-5"></v-divider>
                            <PeriodsTable :periods="customer.periods" />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import CustomerModel from '@/models/Customer'
import ModulesTable from '@/shared/components/ModulesTable'
import PeriodsTable from '@/components/table/PeriodsTable'
import CardHeader from '@/components/utils/CardHeader'
import CustomerDetails from '@/components/common/CustomerDetails'
import CustomerTabs from '@/components/common/CustomerTabs'
import { mapGetters } from 'vuex'

export default {
    props: ['id'],

    data: () => {
        return {
            customer: null,
        }
    },

    components: {
        ModulesTable,
        CardHeader,
        PeriodsTable,
        CustomerDetails,
        CustomerTabs,
    },

    methods: {
        async getCustomer() {
            let customer = await this.model.find(this.id)
            this.customer = customer
        },

        saved() {
            this.$router.push({ name: 'customers' })
        },
    },

    computed: {
        ...mapGetters({
            billable: 'reseller/billable',
            isBusinessConsultant: 'reseller/isBusinessConsultant',
        }),
        model() {
            return new CustomerModel()
        },
    },

    created() {
        this.getCustomer()
    },
}
</script>
